/* eslint-disable no-underscore-dangle */
// General dependencies
import _ from '@centerhealth/common/lodash';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

// Local dependencies
import { config } from '@centerhealth/fe/config';
import { IHTTP, AxiosAbstract } from '@centerhealth/common/http';

type HeadersObject = {
  [key: string]: string;
};

// Extends AXIOS_ABSTRACT implementations and override the interceptors logic
class AxiosHttp extends AxiosAbstract implements IHTTP<AxiosInstance> {
  constructor() {
    super();
    this._initRequestInterceptor();
    this._initRespondeInterceptor();
  }

  _initRequestInterceptor = () => {
    // Add a request interceptor
    this._client.interceptors.request.use(
      (reqConfig: AxiosRequestConfig) => {
        // Check if we have a full url "http://center.health/v1/route" or an endpoint "v1/route"
        // If we have an endpoint append a baseUrl to the request
        const fullUrl = reqConfig.url?.toLocaleLowerCase()?.includes('http') ?? false;
        if (!fullUrl) {
          reqConfig.baseURL = `${config.apiUrl}/`;
        }
        const headers = this.setRequestHeaders(reqConfig.url, reqConfig.headers);
        reqConfig.headers = headers;
        return reqConfig;
      },
      (error) => Promise.reject(error)
    );
  };

  _initRespondeInterceptor = () => {
    // Add a response interceptor
    this._client.interceptors.response.use(
      (response) => response,
      (error) => Promise.reject(error)
    );
  };

  // Private auth request interceptor
  private setRequestHeaders = (url: string, headers: HeadersObject) => {
    // Ignore if not API call
    // TODO: design more robust way to exclude local files
    const fileExtension = url.substr(url.lastIndexOf('.'));
    if (_.includes(['.html', '.md'], fileExtension)) {
      return headers;
    }

    // TODO: include User service to get user JWT  //coreStorageService.getItem('jwtToken');
    const token = '';
    if (!_.isEmpty(token)) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  };

  // TODO: need user service . or implements in site-app error handling hooks
  // Public auth error interceptor
  // private responseErrorInterceptor = (err) => {
  // Ignore if not error 401 (Unauthorized)
  // if (err.status !== 401) {
  //   return;
  // }

  // If unauthorized, redirect to login
  // Check if redirect already in progress
  // if (_.isDefined($rootScope.redirectInProgress)) {
  //   return;
  // }

  // Avoid logout race condition preventing us from having a graceful logout message by only triggering it once
  // $rootScope.redirectInProgress = true;

  // If token was present, means it expired
  // const queryParams = {};
  // if (coreStorageService.getItem('jwtToken') !== null) {
  //   queryParams.successMsg =
  //     "Hey there, you've been automatically logged out to protect your privacy! Please log in again to proceed :)";
  // }

  // coreAuthUnsetService.unsetUser(queryParams);
  // };
}

// Export a singleton
export const HttpService: AxiosHttp = new AxiosHttp();
